module.exports = __webpack_public_path__ + "components/switch-units/static/icon-settings-a5cffddf2cf12eb6fb6db717f6f3e7d4.svg";